module.exports = __webpack_public_path__ + "static/img/sportGame4.936569c.webp";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/head/sportGame4.webp
// module id = xy5H
// module chunks = 3